module.exports = {"name":"Tech Green","description":"Tech Green is a central greenspace on Georgia Tech's campus. It is adjacent to the campanile and student center as well as the Clough Undergraduate Learning Center (CULC).","parking":"Parking on Georgia Tech's campus is not easy if you do not have a parking pass. There is a paid visitor parking lot behind the student center off Ferst Dr.","location":"https://www.google.com/maps/place/Tech+Green/@33.7746837,-84.3972347,18.64z"}


//////////////////
// WEBPACK FOOTER
// ./src/data/tech-green.json
// module id = ./src/data/tech-green.json
// module chunks = main